import { render } from "./HelloWorld.vue?vue&type=template&id=4199caee&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=4199caee&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/Philippines/phi_spread_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4199caee"]])

export default __exports__